
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { catchError, map, Observable } from "rxjs";
import { EmissionStatus, EmissionStatusCode, PsaEmissionUpdateStatus, PsaHarvest, PsaProjectEmission } from "src/app/shared/interfaces/psa-project-emission";
import { EmissionCreditService } from "../../services/emission-credit.service";
import { HttpErrorResponse } from "@angular/common/http";
import { ProjectTable } from "src/app/components/project-table/project-table.component";
import { PsaAuthorizationService } from "src/app/services/auth/psa-authorization.service";
import { ModalWithInputTextComponent } from "src/app/components/modal-with-input-text/modal-with-input-text.component";
import { ModalConfirmationComponent } from "src/app/components/modal-confirmation/modal-confirmation.component";
import { formatCPFOrCNPJ } from "src/app/helpers/utils/cpf-cnpj.util";
import { AppModalService } from "src/app/shared/services/app-modal.service";
import { AppToastService } from "src/app/shared/services/app-toast.service";
@Component({
  standalone: false,
  selector: 'app-emission-confirmation',
  templateUrl: './emission-visualization.component.html',
  styleUrls: ['./emission-visualization.component.scss']
})
export class EmissionVisualizationComponent extends ProjectTable<PsaHarvest> implements OnInit {
  @ViewChild('content') content!: ElementRef;

  override onPageChange(currentPage: number): void {

  }



  emissionId: string | null = null;
  emission: PsaProjectEmission | undefined;

  /*Steper Status*/
  isEmissionCompleted: boolean = false;
  isAuditCompleted: boolean = false;
  isReportCompleted: boolean = false;
  isRegisteredCompleted: boolean = false;

  isEmissionCompletedError: boolean = false;
  isAuditCompletedError: boolean = false;
  isReportCompletedError: boolean = false;
  isRegisteredCompletedError: boolean = false;

  steperSelectindex: number = 4;

  /*Botões Validation */
  isButtonAuditRejectEmission: boolean = false;
  isButtonAuditApproveEmission: boolean = false;

  isButtonUserRejectReport: boolean = false;
  isButtonUserAproveReport: boolean = false;

  isButtonCloneEmission: boolean = false;

  constructor(
    private routeActivate: ActivatedRoute,
    private emissionCreditService: EmissionCreditService,
    private router: Router,
    private psaAuthorizationService: PsaAuthorizationService,
    private modalService: AppModalService,
    private b3ToastService: AppToastService,
    private datePipe: DatePipe,
  ) {
    super()
  }

  ngOnInit(): void {
    this.routeActivate.paramMap.subscribe(params => {
      this.emissionId = params.get('emissionId');
    });
    this.loadInitialData();

    sessionStorage.removeItem("CLONE_EMISSION_OBJECT");
  }

  loadInitialData() {
    this.loadCreditEmissions().subscribe(emission => {
      if (emission) {
        this.emission = this.parseEmissionLoad(emission);
        this.emission = emission;
        this.itens = emission.harvests

        this.loadSteper();
        this.loadButtons();
      } else {
        console.error("Não foi possível obter os dados da emissão informada")
      }
    });
  }

  parseEmissionLoad(emission: PsaProjectEmission): PsaProjectEmission | undefined {
    emission = this.emissionCreditService.parseEmissionStatus([emission])[0];

    emission.harvests.map(harvest => {
      harvest.developerName = harvest.developer?.name
      harvest.developerId = harvest.developer?.id
    })

    emission.endDate = this.formatDateOrDefault(emission.endDate, 'dd/MM/yyyy', '00/00/0000');
    emission.startDate = this.formatDateOrDefault(emission.startDate, 'dd/MM/yyyy', '00/00/0000');
    emission.insertDate = this.formatDateOrDefault(emission.insertDate, 'dd/MM/yyyy HH:mm', '00/00/0000 00:00');

    const cleanedValue = emission.cpfCnpjCode ? emission.cpfCnpjCode.replace(/[^a-zA-Z0-9]/g, "") : "";
    emission.cpfCnpjCode = formatCPFOrCNPJ(cleanedValue);

    emission = this.validateIdShowReasonField(emission);

    return emission;
  }

  private formatDateOrDefault(
    value: string | undefined,
    format: string,
    fallback: string,
  ): string {
    if (value == null || value === '') {
      return fallback;
    }

    const parsedDate = new Date(value);
    if (isNaN(parsedDate.getTime())) {
      return value;
    }

    return this.datePipe.transform(parsedDate, format) || fallback;
  }

  validateIdShowReasonField(emission: PsaProjectEmission): PsaProjectEmission {
    if (emission.status === EmissionStatus.REJECTED_BY_AUDITOR
    ) {
      emission.showReason = true;
    }

    return emission;
  }

  resetSteper() {
    this.isEmissionCompleted = false;
    this.isAuditCompleted = false;
    this.isReportCompleted = false;
    this.isRegisteredCompleted = false;

    this.isEmissionCompletedError = false;
    this.isAuditCompletedError = false;
    this.isReportCompletedError = false;
    this.isRegisteredCompletedError = false;
  }

  loadSteper() {

    this.resetSteper();

    if (this.emission?.status === EmissionStatus.PENDING_AUDITOR_VERIFICATION ||
      this.emission?.status === EmissionStatus.ADJUSTED_BY_DEVELOPER
    ) {
      this.isEmissionCompleted = true;
      this.steperSelectindex = 1;
    }

    if (this.emission?.status === EmissionStatus.REJECTED_BY_AUDITOR
    ) {
      this.isEmissionCompleted = true;
      this.isAuditCompletedError = true;
      this.steperSelectindex = 1;
    }

    if (this.emission?.status === EmissionStatus.APPROVED_BY_AUDITOR ||
      this.emission?.status === EmissionStatus.PENDING_DEVELOPER_CONFIRMATION
    ) {
      this.isEmissionCompleted = true;
      this.isAuditCompleted = true;
      this.steperSelectindex = 2;
    }

    if (this.emission?.status === EmissionStatus.REJECTED_BY_DEVELOPER
    ) {
      this.isEmissionCompleted = true;
      this.isAuditCompleted = true;
      this.isReportCompletedError = true;
      this.steperSelectindex = 2;
    }

    if (this.emission?.status === EmissionStatus.REGISTERED_IN_B3 ||
      this.emission?.status === EmissionStatus.CONFIRMED_BY_DEVELOPER
    ) {
      this.isEmissionCompleted = true;
      this.isAuditCompleted = true;
      this.isReportCompleted = true;
      this.isRegisteredCompleted = true;
      this.steperSelectindex = 3;
    }
  }

  loadCreditEmissions(): Observable<PsaProjectEmission | undefined> {
    return this.emissionCreditService.getEmissionById(Number(this.emissionId)).pipe(
      map((res) => res?.data || undefined),
      catchError(error => {
        console.error("Erro ao carregar emissões de crédito. Stack error: ", error);
        return [undefined];
      })
    );
  }



  private loadButtons() {
    this.disableAllButtons();
    const psaFunctions = this.psaAuthorizationService.getFunctions();
    const hasAudit = psaFunctions.some((f: any) => f.functionCode === 'CAR_PSA_AUDITA_PROJETO');
    const hasRegister = psaFunctions.some((f: any) => f.functionCode === 'CAR_PSA_REGISTRA_PROJETO');

    if (hasAudit) {
      if (this.emission?.status === EmissionStatus.PENDING_AUDITOR_VERIFICATION) {
        this.isButtonAuditApproveEmission = true;
        this.isButtonAuditRejectEmission = true;
      }
    }

    if (hasRegister) {
      if (this.emission?.status === EmissionStatus.PENDING_DEVELOPER_CONFIRMATION ||
        this.emission?.status === EmissionStatus.REJECTED_BY_DEVELOPER
      ) {
        this.isButtonUserAproveReport = true;
      }
      if (this.emission?.status === EmissionStatus.PENDING_DEVELOPER_CONFIRMATION) {
        this.isButtonUserRejectReport = true;
      }
      if (this.emission?.status === EmissionStatus.REJECTED_BY_AUDITOR) {
        this.isButtonCloneEmission = true;
      }
    }
  }

  private disableAllButtons() {
    this.isButtonAuditRejectEmission = false;
    this.isButtonAuditApproveEmission = false;

    this.isButtonUserRejectReport = false;
    this.isButtonUserAproveReport = false;

    this.isButtonCloneEmission =  false;
  }

  navigateToEmissionConsult() {
    this.router.navigate(['/consulta-emissao-credito']);
  }

  exportToCSV() {

    const list: PsaProjectEmission[] = []

    if (this.emission) list.push(this.emission);

    // Achatar os dados
    const flattenedData = this.flattenData(list);

    // Definir as colunas
    const headers = Object.keys(flattenedData[0]);

    // Construir o CSV
    const csvContent =
      // Adicionar BOM para suporte a caracteres especiais no Excel
      '\ufeff' +
      headers.join(';') + '\n' +
      flattenedData.map(row => headers.map(field => this.formatCSVField(row[field])).join(';')).join('\n');

    // Criar Blob e fazer o download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const filename = 'PSA_Emissao_Credito_' + this.emission?.serialCode + '.csv';
    this.downloadBlob(blob, filename);
    this.b3ToastService.show({
      variant: 'success',
      label: 'Arquivo com detalhes exportado com sucesso!',
    });
  }

  private flattenData(emissions: PsaProjectEmission[]): any[] {
    const flattened: any[] = [];

    emissions.forEach(emission => {
        emission.harvests.forEach(harvest => {
          flattened.push({
            ID_DO_PROJETO: emission.project?.id,
            NOME_DO_PROJETO: emission.project?.name || '',
            ID_DA_EMISSAO: emission.id,
            SERIAL_CODE_EMISSAO: emission.serialCode,
            STATUS_DA_EMISSAO: emission.status,
            MOTIVO_REPROVACAO: emission.reasonRejection,
            DATE_DE_REGISTRO: emission.insertDate,
            NUMERO_EMISSAO: emission.emissionNumber,
            QUANTIDADE_TOTAL_EMISSAO: emission.emissionQuantity,
            DATA_INICIO: emission.startDate,
            DATA_FIM: emission.endDate,
            CNPJ_DESENVOLVEDOR:emission.cpfCnpjCode,
            CONTA_DETENTOR:emission.holderCode,
            ID_SAFRA: harvest.id,
            ANO_SAFRA: harvest.harvestYear,
            QUANTIDADE_SAFRA: harvest.quantity,
            NOME_DESENVOLVEDOR: harvest.developerName,
            ID_DESENVOLVEDOR: harvest.developerId,
            LINK_PARA_RM: emission.rmLink,
            DETALHES: emission.details,
          });
        });
    });

    return flattened;
  }

  /**
  * Formata um campo para o CSV, escapando caracteres especiais.
  */
  private formatCSVField(field: any): string {
    if (field === null || field === undefined) {
      return '';
    }

    // Se o campo contém vírgulas, aspas ou quebras de linha, ele deve ser envolvido por aspas.
    const fieldString = field.toString().replace(/"/g, '""'); // Escapa as aspas
    if (fieldString.search(/("|,|\n)/g) >= 0) {
      return `"${fieldString}"`;
    }

    return fieldString;
  }


  private downloadBlob(blob: Blob, filename: string) {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  actionAuditRejectEmission() {
    this.modalService.open(ModalWithInputTextComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      actionType: 'reject',
      title: 'Deseja rejeitar a emissão?',
      content: `Digite o motivo para rejeitar a emissão`,
      closeButton: true
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        this.updateEmissionStatus(result, EmissionStatusCode.REJECTED_BY_AUDITOR, false)
      }
    });
  }

  public actionAuditAproveEmission(): void {
    let msg = 'Deseja aprovar esta emissão?';

    this.modalService.open(ModalConfirmationComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      title: 'Aprovar emissão',
      content: msg,
      closeButton: true,
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        this.updateEmissionStatus(result, EmissionStatusCode.PENDING_DEVELOPER_CONFIRMATION, true)
      }
    })
  }

  actionEmissorRejectReportRecieved() {
    this.modalService.open(ModalConfirmationComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      actionType: 'reject',
      title: 'Deseja informar o não recebimento do Relatório de Monitoramento?',
      content: ``,
      closeButton: true
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        this.updateEmissionStatus(result, EmissionStatusCode.REJECTED_BY_DEVELOPER, false)
      }
    });
  }

  public actionEmissorAproveReportRecivied(): void {
    let msg = 'Deseja confirmar o recebimento do Relatório de Monitoramento?';

    this.modalService.open(ModalConfirmationComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      title: 'Confirmar recebimento',
      content: msg,
      closeButton: true,
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        this.updateEmissionStatus(result, EmissionStatusCode.REGISTERED_IN_B3, true)
      }
    })
  }

  private updateEmissionStatus(result: any, status: EmissionStatusCode, reasonNull:boolean) {

    const data: PsaEmissionUpdateStatus = {} as PsaEmissionUpdateStatus;

    if(reasonNull){
      data.description = "";
    }else{
      data.description = result.data.reasonText;
    }
    
    data.status = status;

    if (this.emissionId) {
      this.emissionCreditService.projectEmissionUpdateStatus(Number(this.emissionId), data).subscribe({
        next: () => {
          this.b3ToastService.show({
            status: 'success',
            text: 'Status da emissão atualizado com sucesso.'
          });
          this.loadInitialData();
        },
        error: (err) => {
          const apiError = this.extractApiError(err);
          console.error('Erro ao atualizar o status da emissão para ' + status, {
            httpStatus: apiError.status,
            code: apiError.code,
            message: apiError.message,
            details: apiError.details,
            raw: apiError.raw
          });
          this.b3ToastService.show({
            status: 'warning',
            text: this.resolveEmissionStatusErrorMessage(err)
          });
        }
      });
    } else {
      console.error("Id da Emissão Inválido, não é possível atualizar o status da emissão para " + status)
    }
  }

  private extractApiError(err: unknown): {
    status: number | null;
    code: string | null;
    message: string | null;
    details: string | null;
    raw: unknown;
  } {
    if (!(err instanceof HttpErrorResponse)) {
      return { status: null, code: null, message: null, details: null, raw: err };
    }

    const payload = err.error;
    const firstError = Array.isArray(payload) && payload.length > 0
      ? payload[0]
      : payload;

    if (firstError && typeof firstError === 'object') {
      const errorObject = firstError as { code?: string; message?: string; details?: string };
      return {
        status: err.status,
        code: errorObject.code ?? null,
        message: errorObject.message ?? null,
        details: errorObject.details ?? null,
        raw: payload
      };
    }

    return {
      status: err.status,
      code: null,
      message: typeof payload === 'string' ? payload : err.statusText,
      details: null,
      raw: payload
    };
  }

  private resolveEmissionStatusErrorMessage(err: unknown): string {
    const defaultMessage = 'Não foi possível atualizar o status da emissão. Tente novamente ou contate o suporte.';
    const apiError = this.extractApiError(err);

    if (apiError.code === 'CertifierCreditEntityNotFound') {
      return 'Certificadora PSA Carbon Agro Perene não encontrada no banco deste ambiente. Confirme o INSERT em DEV e use npm run start:dev.';
    }

    if (apiError.code === 'InvalidStatusTransition') {
      return 'Transição de status não permitida. A emissão precisa estar aguardando confirmação do desenvolvedor.';
    }

    if (apiError.code === 'InvalidHarvestTotalQuantity') {
      return 'Quantidade total de créditos da emissão é inválida (zero ou nula).';
    }

    if (apiError.code === 'NotAuthorized') {
      return 'Usuário sem permissão ou sem conta vinculada para registrar o crédito de carbono.';
    }

    if (apiError.code === 'UnmappedError' && (apiError.details || apiError.message || '').includes('BigInteger')) {
      return 'Bug conhecido no issuer remoto (IdentityGenerator). Rode a API local com o fix e use npm run start:local.';
    }

    if (apiError.code === 'UnmappedError') {
      return `Erro interno na API: ${apiError.details || apiError.message || 'sem detalhes'}.`;
    }

    const readableMessage = apiError.details || apiError.message;
    if (readableMessage) {
      return apiError.code
        ? `[${apiError.code}] ${readableMessage}`
        : readableMessage;
    }

    if (apiError.status === 500) {
      return 'Erro interno ao registrar o crédito. Use npm run start:local com a API issuer rodando localmente, ou aguarde deploy do fix no DEV.';
    }

    return defaultMessage;
  }

  actionCloneEmission(){

    let msg = 'Deseja clonar esta Emissão?';

    this.modalService.open(ModalConfirmationComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      title: 'Clonar Emissão',
      content: msg,
      closeButton: true,
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        const serializedObject = JSON.stringify(this.emission ? this.emission : "");
        sessionStorage.setItem("CLONE_EMISSION_OBJECT", serializedObject);
        this.router.navigate(['/registro-emissao-credito']);
      }
    })
  }

  sortEmissionIdByDesc(data: PsaProjectEmission[]) {
    return data.sort((a, b) => {
      const emissionIdA = a.id ?? 0;
      const emissionIdB = b.id ?? 0;
      return emissionIdB - emissionIdA;
    });
  }
}